var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[("wac-cms-highlightbox " + _vm.hasTwoItemsClass)]},[_c('wac-background',{attrs:{"variant":_vm.variant}},[_vm._t("left")],2),(_vm.hasRightItem)?_c('wac-background',{attrs:{"variant":"light"}},[_vm._t("right")],2):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }